<template>
  <div class="prev-commission-transactions">
    <table class="table previous-commissions-table mb-0">
      <thead>
        <tr>
          <th>
            Description
          </th>
          <th>
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(transaction, index) in commissionTransactions" :key="index" class="has-coe">
          <td>
            {{ transaction.description }}
          </td>
          <td>
            {{ formattedNumbers(transaction.total) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatCurrency } from "../../../utils/helpers";

export default {
  name: 'PreviousCommissionTransactions',
  props: {
    commissionTransactions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    formattedNumbers(number) {
      return formatCurrency(number);
    },
  }
}
</script>